import React, { useCallback, useState } from 'react';
import { SendDocument } from '@/components/screens/lawyerapp/cases/case-clients/send-document';
import { ModalSelectUsers } from '@/components/screens/lawyerapp/cases/case-clients/request-document';
import { PhaseName } from '@/interfaces';

interface UseSendDocumentModalsProps {
	caseId: string;
	caseName: string;
	phaseName: PhaseName;
	isToAllUsers?: boolean;
	selectedUserIds: (string | null)[];
	setSelectedUserIds: React.Dispatch<React.SetStateAction<(string | null)[]>>;
}

export const useSendDocumentModals = ({
	caseId,
	caseName,
	isToAllUsers = false,
	phaseName,
	selectedUserIds,
	setSelectedUserIds,
}: UseSendDocumentModalsProps) => {
	const [isOpenSelectUsers, setIsOpenSelectUsers] = useState(false);
	const [isOpenSendDocument, setIsOpenSendDocument] = useState(false);

	const onOpenSendDocument = useCallback(() => {
		if (isToAllUsers) {
			setIsOpenSelectUsers(true);
		} else {
			setIsOpenSendDocument(true);
		}
	}, [isToAllUsers]);

	const handleCloseSelectUsers = useCallback(() => {
		setIsOpenSelectUsers(false);
		setSelectedUserIds([]);
	}, [setSelectedUserIds]);

	const handleContinueSelectUsers = useCallback(() => {
		setIsOpenSelectUsers(false);
		setIsOpenSendDocument(true);
	}, []);

	const renderSendDocumentModals = (
		<>
			<ModalSelectUsers
				open={isOpenSelectUsers}
				setOpen={setIsOpenSelectUsers}
				selectedUserIds={selectedUserIds}
				setSelectedUserIds={setSelectedUserIds}
				onContinue={handleContinueSelectUsers}
				phaseName={phaseName}
				title="Send Document"
				onClose={handleCloseSelectUsers}
			/>

			<SendDocument
				caseId={caseId}
				caseName={caseName}
				open={isOpenSendDocument}
				setOpen={setIsOpenSendDocument}
				userIds={selectedUserIds.filter((id) => id !== null) as string[]}
				setSelectedUserIds={setSelectedUserIds}
				onBack={isToAllUsers ? undefined : () => {}}
			/>
		</>
	);

	return {
		onOpenSendDocument,
		renderSendDocumentModals,
		setIsOpenSendDocument,
		selectedUserIds,
	};
};
